{
  "PROFILE_SETTINGS": {
    "LINK": "Profiili seaded",
    "TITLE": "Profiili seaded",
    "BTN_TEXT": "Uuenda profiili",
    "DELETE_AVATAR": "Kustuta avatar",
    "AVATAR_DELETE_SUCCESS": "Avatar on edukalt kustutatud",
    "AVATAR_DELETE_FAILED": "Avatari kustutamisel tekkis viga, palun proovi uuesti",
    "UPDATE_SUCCESS": "Teie profiil on edukalt uuendatud",
    "PASSWORD_UPDATE_SUCCESS": "Teie parool on edukalt muudetud",
    "AFTER_EMAIL_CHANGED": "Teie profiil on edukalt uuendatud, palun logige uuesti sisse, kuna teie sisselogimisandmed on muutunud",
    "FORM": {
      "PICTURE": "Profiilipilt",
      "AVATAR": "Profiilipilt",
      "ERROR": "Palun parandage vormi vead",
      "REMOVE_IMAGE": "Eemalda",
      "UPLOAD_IMAGE": "Laadi pilt üles",
      "UPDATE_IMAGE": "Uuenda pilti",
      "PROFILE_SECTION": {
        "TITLE": "Profiil",
        "NOTE": "Sinu e-posti aadress on sinu identiteet ja seda kasutatakse sisselogimiseks."
      },
      "SEND_MESSAGE": {
        "TITLE": "Kiirklahv sõnumite saatmiseks",
        "NOTE": "Saad valida otsetee (Enter või Cmd/Ctrl+Enter) vastavalt oma kirjutamise eelistusele.",
        "UPDATE_SUCCESS": "Sinu seaded on edukalt uuendatud",
        "CARD": {
          "ENTER_KEY": {
            "HEADING": "Sisesta (↵)",
            "CONTENT": "Saada sõnum Enter-klahviga, mitte saatmisnuppu vajutades."
          },
          "CMD_ENTER_KEY": {
            "HEADING": "Cmd/Ctrl + Enter (⌘ + ↵)",
            "CONTENT": "Sõnumite saatmine Cmd/Ctrl + Enter klahviga, mitte saatmisnuppu vajutades."
          }
        }
      },
      "INTERFACE_SECTION": {
        "TITLE": "Liides",
        "NOTE": "Kohanda Chatwoot juhtpaneeli välimust ja kasutuskogemust.",
        "FONT_SIZE": {
          "TITLE": "Fondi suurus",
          "NOTE": "Reguleeri teksti suurust kogu armatuurlaual vastavalt oma eelistustele.",
          "UPDATE_SUCCESS": "Sinu fondi seaded on edukalt uuendatud",
          "UPDATE_ERROR": "Fondiseadete uuendamisel tekkis viga, palun proovi uuesti",
          "OPTIONS": {
            "SMALLER": "Väiksem",
            "SMALL": "Väike",
            "DEFAULT": "Vaikimisi",
            "LARGE": "Suur",
            "LARGER": "Suurem",
            "EXTRA_LARGE": "Ekstra suur"
          }
        },
        "LANGUAGE": {
          "TITLE": "Eelistatud keel",
          "NOTE": "Vali keel, mida soovid kasutada.",
          "UPDATE_SUCCESS": "Sinu keelesätted on edukalt uuendatud",
          "UPDATE_ERROR": "Keele seadete uuendamisel tekkis viga, palun proovi uuesti",
          "USE_ACCOUNT_DEFAULT": "Kasuta konto vaikekeelt"
        }
      },
      "MESSAGE_SIGNATURE_SECTION": {
        "TITLE": "Isiklik sõnumi allkiri",
        "NOTE": "Loo unikaalne sõnumi allkiri, mis kuvatakse iga sinu saadetud sõnumi lõpus igast postkastist. Võid lisada ka rida pildina, mida toetavad live chat, e-post ja API postkastid.",
        "BTN_TEXT": "Salvesta sõnumi allkiri",
        "API_ERROR": "Allkirja salvestamine ebaõnnestus! Proovi uuesti",
        "API_SUCCESS": "Allkiri salvestati edukalt",
        "IMAGE_UPLOAD_ERROR": "Pildi üleslaadimine ebaõnnestus! Proovi uuesti",
        "IMAGE_UPLOAD_SUCCESS": "Pilt lisatud edukalt. Palun klõpsa salvestamiseks nuppu Salvesta",
        "IMAGE_UPLOAD_SIZE_ERROR": "Pildi suurus peab olema väiksem kui {size}MB",
        "INLINE_IMAGE_WARNING": "Pasted inline images were removed. Please use the image upload button to add images to your signature."
      },
      "MESSAGE_SIGNATURE": {
        "LABEL": "Sõnumi allkiri",
        "ERROR": "Sõnumi allkiri ei tohi olla tühi",
        "PLACEHOLDER": "Sisesta siia oma isiklik sõnumi allkiri."
      },
      "PASSWORD_SECTION": {
        "TITLE": "Parool",
        "NOTE": "Parooli uuendamine logib sind välja kõigis seadmetes.",
        "BTN_TEXT": "Muuda parooli"
      },
      "SECURITY_SECTION": {
        "TITLE": "Turvalisus",
        "NOTE": "Halda oma konto täiendavaid turvafunktsioone.",
        "MFA_BUTTON": "Manage Two-Factor Authentication"
      },
      "ACCESS_TOKEN": {
        "TITLE": "Juurdepääsu token",
        "NOTE": "Seda tokenit saab kasutada API-põhise integratsiooni loomisel.",
        "COPY": "Kopeeri",
        "RESET": "Lähtesta",
        "CONFIRM_RESET": "Oled kindel?",
        "CONFIRM_HINT": "Kinnita uuesti klõpsates",
        "RESET_SUCCESS": "Access token regenerated successfully",
        "RESET_ERROR": "Juurdepääsu tokeni uuendamine ebaõnnestus. Palun proovi uuesti"
      },
      "AUDIO_NOTIFICATIONS_SECTION": {
        "TITLE": "Helihoiatused",
        "NOTE": "Luba armatuurlaual helihoiatused uute sõnumite ja vestluste puhul.",
        "PLAY": "Esita heli",
        "ALERT_TYPES": {
          "NONE": "Puudub",
          "MINE": "Määratud",
          "ALL": "Kõik",
          "ASSIGNED": "Minule määratud vestlused",
          "UNASSIGNED": "Määramata vestlused",
          "NOTME": "Avatud vestlused, mis on määratud teistele"
        },
        "ALERT_COMBINATIONS": {
          "NONE": "Sa ei ole valinud ühtegi valikut, sa ei saa helihoiatusi.",
          "ASSIGNED": "Sa saad hoiatusi sulle määratud vestluste kohta.",
          "UNASSIGNED": "Sa saad hoiatusi kõigi määramata vestluste kohta.",
          "NOTME": "Sa saad hoiatusi teistele määratud vestluste kohta.",
          "ASSIGNED+UNASSIGNED": "Sa saad hoiatusi nii sulle määratud kui ka hooldamata vestluste kohta.",
          "ASSIGNED+NOTME": "Sa saad hoiatusi sulle ja teistele määratud vestluste kohta, kuid mitte määramata vestluste kohta.",
          "NOTME+UNASSIGNED": "Sa saad hoiatusi hooldamata vestluste ja teistele määratud vestluste kohta.",
          "ASSIGNED+NOTME+UNASSIGNED": "Sa saad hoiatusi kõigi vestluste kohta."
        },
        "ALERT_TYPE": {
          "TITLE": "Hoiatuste sündmused vestluste jaoks",
          "NONE": "Puudub",
          "ASSIGNED": "Määratud vestlused",
          "ALL_CONVERSATIONS": "Kõik vestlused"
        },
        "DEFAULT_TONE": {
          "TITLE": "Hoiatusheli:"
        },
        "CONDITIONS": {
          "TITLE": "Hoiatusseisundid:",
          "CONDITION_ONE": "Helimärguanded ainult siis, kui brauseri aken pole aktiivne",
          "CONDITION_TWO": "Saada teavitusi iga 30 sekundi järel, kuni kõik määratud vestlused on loetud"
        },
        "SOUND_PERMISSION_ERROR": "Automaatsel mängimisel on sinu brauseris keelatud. Et kuulda teavitusi automaatselt, luba heliõigused brauseri seadetes või suhtle lehega.",
        "READ_MORE": "Loe rohkem"
      },
      "EMAIL_NOTIFICATIONS_SECTION": {
        "TITLE": "E-posti teavitused",
        "NOTE": "Muuda siin oma e-posti teavituste eelistusi",
        "CONVERSATION_ASSIGNMENT": "Saada e-posti teavitus, kui mulle määratakse vestlus",
        "CONVERSATION_CREATION": "Saada e-posti teavitus, kui luuakse uus vestlus",
        "CONVERSATION_MENTION": "Saada e-kirjaga teavitus, kui sind vestluses mainitakse",
        "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Saada e-kirjaga teavitus, kui määratud vestlusesse lisatakse uus sõnum",
        "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Saada e-posti teavitus, kui osalevas vestluses luuakse uus sõnum",
        "SLA_MISSED_FIRST_RESPONSE": "Saada e-kiri, kui vestlusel jääb esimese vastuse SLA täitmata",
        "SLA_MISSED_NEXT_RESPONSE": "Saada e-kiri, kui vestlusel jääb järgmise vastuse SLA täitmata",
        "SLA_MISSED_RESOLUTION": "Saada e-kiri, kui vestlusel jääb lahenduse SLA täitmata"
      },
      "NOTIFICATIONS": {
        "TITLE": "Teavituste eelistused",
        "TYPE_TITLE": "Teavituse tüüp",
        "EMAIL": "E-post",
        "PUSH": "Push-teavitus",
        "TYPES": {
          "CONVERSATION_CREATED": "Luuakse uus vestlus",
          "CONVERSATION_ASSIGNED": "Vestlus määratakse sulle",
          "CONVERSATION_MENTION": "Sind mainitakse vestluses",
          "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Määratud vestluses luuakse uus sõnum",
          "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Osalevas vestluses luuakse uus sõnum",
          "SLA_MISSED_FIRST_RESPONSE": "Vestlus ei vasta esimesele SLA vastusele",
          "SLA_MISSED_NEXT_RESPONSE": "Vestlus ei vasta järgmisele SLA vastusele",
          "SLA_MISSED_RESOLUTION": "Vestlus ei vasta lahenduse SLA nõuetele"
        },
        "BROWSER_PERMISSION": "Luba brauseri tõuketeavitused, et neid vastu võtta"
      },
      "API": {
        "UPDATE_SUCCESS": "Teavituste eelistused on edukalt uuendatud",
        "UPDATE_ERROR": "Eelistuste uuendamisel tekkis viga, palun proovige uuesti"
      },
      "PUSH_NOTIFICATIONS_SECTION": {
        "TITLE": "Push-teavitused",
        "NOTE": "Muuda siin oma tõukemärguannete eelistusi",
        "CONVERSATION_ASSIGNMENT": "Saada tõukemärguanne, kui vestlus määratakse mulle",
        "CONVERSATION_CREATION": "Saada tõukemärguanne, kui luuakse uus vestlus",
        "CONVERSATION_MENTION": "Saada tõuketeavitusi, kui sind vestluses mainitakse",
        "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Saada tõukemärguanne, kui määratud vestlusesse lisatakse uus sõnum",
        "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Saada push-teavitus, kui osalevas vestluses luuakse uus sõnum",
        "HAS_ENABLED_PUSH": "Tõukemärguanded on selles brauseris lubatud.",
        "REQUEST_PUSH": "Luba tõukemärguanded",
        "SLA_MISSED_FIRST_RESPONSE": "Saada push-teavitus, kui vestlusel jääb esimese vastuse SLA täitmata",
        "SLA_MISSED_NEXT_RESPONSE": "Saada push-teavitus, kui vestlusel jääb järgmise vastuse SLA täitmata",
        "SLA_MISSED_RESOLUTION": "Saada push-teavitus, kui vestlusel jääb lahenduse SLA täitmata"
      },
      "PROFILE_IMAGE": {
        "LABEL": "Profiilipilt"
      },
      "NAME": {
        "LABEL": "Teie täisnimi",
        "ERROR": "Palun sisestage kehtiv täisnimi",
        "PLACEHOLDER": "Palun sisestage oma täisnimi"
      },
      "DISPLAY_NAME": {
        "LABEL": "Kuvamise nimi",
        "ERROR": "Palun sisestage kehtiv kuvamise nimi",
        "PLACEHOLDER": "Palun sisestage kuvamise nimi, see kuvatakse vestlustes"
      },
      "AVAILABILITY": {
        "LABEL": "Saadavus",
        "STATUS": {
          "ONLINE": "Veebis",
          "BUSY": "Hõivatud",
          "OFFLINE": "Võrguühenduseta"
        },
        "SET_AVAILABILITY_SUCCESS": "Oleku määramine õnnestus",
        "SET_AVAILABILITY_ERROR": "Oleku määramine ebaõnnestus, palun proovi uuesti",
        "IMPERSONATING_ERROR": "Sa ei saa muuta saadavust, kui esindad teist kasutajat"
      },
      "EMAIL": {
        "LABEL": "Teie e-posti aadress",
        "ERROR": "Palun sisestage kehtiv e-posti aadress",
        "PLACEHOLDER": "Palun sisestage oma e-posti aadress, see kuvatakse vestlustes"
      },
      "CURRENT_PASSWORD": {
        "LABEL": "Praegune parool",
        "ERROR": "Palun sisestage praegune parool",
        "PLACEHOLDER": "Palun sisestage praegune parool"
      },
      "PASSWORD": {
        "LABEL": "Uus parool",
        "ERROR": "Palun sisestage vähemalt 6 tähemärgiga parool",
        "PLACEHOLDER": "Palun sisestage uus parool"
      },
      "PASSWORD_CONFIRMATION": {
        "LABEL": "Kinnita uus parool",
        "ERROR": "Kinnitatud parool peab vastama paroolile",
        "PLACEHOLDER": "Palun sisesta oma uus parool uuesti"
      }
    }
  },
  "SIDEBAR_ITEMS": {
    "CHANGE_AVAILABILITY_STATUS": "Muuda",
    "CHANGE_ACCOUNTS": "Vaheta kontot",
    "SWITCH_ACCOUNT": "Vaheta kontot",
    "CONTACT_SUPPORT": "Võta ühendust toega",
    "SELECTOR_SUBTITLE": "Valige allolevast loendist konto",
    "PROFILE_SETTINGS": "Profiili seaded",
    "YEAR_IN_REVIEW": "Aasta ülevaade",
    "KEYBOARD_SHORTCUTS": "Klaviatuuri otseteed",
    "APPEARANCE": "Muuda välimust",
    "SUPER_ADMIN_CONSOLE": "SuperAdmini konsool",
    "DOCS": "Loe dokumentatsiooni",
    "CHANGELOG": "Muudatuste logi",
    "LOGOUT": "Logi välja"
  },
  "APP_GLOBAL": {
    "TRIAL_MESSAGE": "päeva tasuta prooviperiood jäänud.",
    "TRAIL_BUTTON": "Osta kohe",
    "DELETED_USER": "Kustutatud kasutaja",
    "EMAIL_VERIFICATION_PENDING": "Tundub, et sa pole oma e-posti aadressi veel kinnitanud. Palun kontrolli oma postkasti kinnituskirja.",
    "RESEND_VERIFICATION_MAIL": "Saada kinnituskiri uuesti",
    "EMAIL_VERIFICATION_SENT": "Kinnituskiri on saadetud. Palun kontrolli oma postkasti.",
    "ACCOUNT_SUSPENDED": {
      "TITLE": "Konto peatatud",
      "MESSAGE": "Teie konto on peatatud. Lisateabe saamiseks võtke ühendust tugimeeskonnaga."
    },
    "NO_ACCOUNTS": {
      "TITLE": "Kontot ei leitud",
      "MESSAGE_CLOUD": "Te ei kuulu hetkel ühegi konto alla. Kui arvate, et see on viga, võtke palun ühendust meie tugimeeskonnaga.",
      "MESSAGE_SELF_HOSTED": "Te ei kuulu hetkel ühegi konto alla. Palun võtke ühendust oma administraatoriga.",
      "LOGOUT": "Logi välja"
    }
  },
  "COMPONENTS": {
    "CODE": {
      "BUTTON_TEXT": "Kopeeri",
      "CODEPEN": "Ava CodePenis",
      "COPY_SUCCESSFUL": "Kopeeritud lõikelauale"
    },
    "SHOW_MORE_BLOCK": {
      "SHOW_MORE": "Näita rohkem",
      "SHOW_LESS": "Näita vähem"
    },
    "FILE_BUBBLE": {
      "DOWNLOAD": "Laadi alla",
      "UPLOADING": "Laadimine...",
      "INSTAGRAM_STORY_UNAVAILABLE": "See lugu pole enam saadaval.",
      "INSTAGRAM_STORY_REPLY": "Vastas su loole:"
    },
    "LOCATION_BUBBLE": {
      "SEE_ON_MAP": "Vaata kaardil"
    },
    "FORM_BUBBLE": {
      "SUBMIT": "Esita"
    },
    "MEDIA": {
      "IMAGE_UNAVAILABLE": "See pilt ei ole enam saadaval.",
      "LOADING_FAILED": "Laadimine ebaõnnestus"
    }
  },
  "CONFIRM_EMAIL": "Kontrollimine...",
  "SETTINGS": {
    "INBOXES": {
      "NEW_INBOX": "Lisa postkast"
    }
  },
  "SIDEBAR": {
    "NO_ITEMS": "Ühtegi eset pole",
    "CURRENTLY_VIEWING_ACCOUNT": "Praegu vaadatakse:",
    "SWITCH": "Vaheta",
    "INBOX_VIEW": "Postkasti vaade",
    "CONVERSATIONS": "Vestlused",
    "INBOX": "Minu postkast",
    "ALL_CONVERSATIONS": "Kõik vestlused",
    "MENTIONED_CONVERSATIONS": "Mainimised",
    "PARTICIPATING_CONVERSATIONS": "Osalevad",
    "UNATTENDED_CONVERSATIONS": "Jäetud tähelepanuta",
    "REPORTS": "Aruanded",
    "SETTINGS": "Seaded",
    "CONTACTS": "Kontaktid",
    "ACTIVE": "Aktiivne",
    "COMPANIES": "Ettevõtted",
    "ALL_COMPANIES": "Kõik ettevõtted",
    "CAPTAIN": "Kapten",
    "CAPTAIN_ASSISTANTS": "Abilised",
    "CAPTAIN_DOCUMENTS": "Dokumendid",
    "CAPTAIN_RESPONSES": "KKK",
    "CAPTAIN_TOOLS": "Tööriistad",
    "CAPTAIN_SCENARIOS": "Stsenaariumid",
    "CAPTAIN_PLAYGROUND": "Mänguväljak",
    "CAPTAIN_INBOXES": "Postkastid",
    "CAPTAIN_SETTINGS": "Seaded",
    "HOME": "Avaleht",
    "AGENTS": "Agendid",
    "AGENT_BOTS": "Botid",
    "AUDIT_LOGS": "Auditilogid",
    "INBOXES": "Postkastid",
    "NOTIFICATIONS": "Teavitused",
    "CANNED_RESPONSES": "Eelmääratud vastused",
    "INTEGRATIONS": "Integratsioonid",
    "PROFILE_SETTINGS": "Profiili seaded",
    "ACCOUNT_SETTINGS": "Konto seaded",
    "APPLICATIONS": "Rakendused",
    "LABELS": "Sildid",
    "CUSTOM_ATTRIBUTES": "Kohandatud atribuudid",
    "AUTOMATION": "Automatiseerimine",
    "MACROS": "Makrod",
    "TEAMS": "Meeskonnad",
    "BILLING": "Arveldamine",
    "CUSTOM_VIEWS_FOLDER": "Kaustad",
    "CUSTOM_VIEWS_SEGMENTS": "Segmendid",
    "ALL_CONTACTS": "Kõik kontaktid",
    "TAGGED_WITH": "Sildistatud",
    "NEW_LABEL": "Uus silt",
    "NEW_TEAM": "Uus meeskond",
    "NEW_INBOX": "Uus postkast",
    "REPORTS_CONVERSATION": "Vestlused",
    "CSAT": "CSAT",
    "LIVE_CHAT": "Otsevestlus",
    "SMS": "SMS",
    "WHATSAPP": "WhatsApp",
    "CAMPAIGNS": "Kampaaniad",
    "ONGOING": "Jätkub",
    "ONE_OFF": "Ühekordne",
    "REPORTS_SLA": "SLA",
    "REPORTS_BOT": "Bot",
    "REPORTS_AGENT": "Agendid",
    "REPORTS_LABEL": "Sildid",
    "REPORTS_INBOX": "Sissetulek",
    "REPORTS_TEAM": "Meeskond",
    "AGENT_ASSIGNMENT": "Esindaja määramine",
    "SET_AVAILABILITY_TITLE": "Määra end kui",
    "SET_YOUR_AVAILABILITY": "Määra oma saadavus",
    "SLA": "SLA",
    "CUSTOM_ROLES": "Kohandatud rollid",
    "BETA": "Beeta",
    "REPORTS_OVERVIEW": "Ülevaade",
    "REAUTHORIZE": "Sinu postkasti ühendus on aegunud, palun ühenda uuesti\n et jätkata sõnumite vastuvõtmist ja saatmist",
    "HELP_CENTER": {
      "TITLE": "Abi keskus",
      "ARTICLES": "Artiklid",
      "CATEGORIES": "Kategooriad",
      "LOCALES": "Keeled",
      "SETTINGS": "Seaded"
    },
    "CHANNELS": "Kanalid",
    "SET_AUTO_OFFLINE": {
      "TEXT": "Märgi automaatselt võrguühenduseta",
      "INFO_TEXT": "Lase süsteemil automaatselt sind võrguühenduseta märkida, kui sa rakendust või juhtpaneeli ei kasuta.",
      "INFO_SHORT": "Märgi automaatselt võrguühenduseta, kui sa rakendust ei kasuta."
    },
    "DOCS": "Loe dokumentatsiooni",
    "SECURITY": "Turvalisus",
    "CAPTAIN_AI": "Kapten",
    "CONVERSATION_WORKFLOW": "Vestluse töövoog"
  },
  "CAPTAIN_SETTINGS": {
    "TITLE": "Captain Settings",
    "DESCRIPTION": "Seadista oma AI mudelid ja funktsioonid Captainile. Captain kasutab krediidipõhist arveldamist, iga Captaini tegevuse eest valitud mudeli alusel võetakse krediite.",
    "LOADING": "Loading Captain configuration...",
    "LINK_TEXT": "Learn more about Captain Credits",
    "NOT_ENABLED": "Captain ei ole sinu kontol lubatud. Palun uuenda oma plaani, et pääseda Captaini funktsioonidele ligi.",
    "MODEL_CONFIG": {
      "TITLE": "Mudeli seadistus",
      "DESCRIPTION": "Vali AI mudelid erinevate funktsioonide jaoks.",
      "SELECT_MODEL": "Vali mudel",
      "CREDITS_PER_MESSAGE": "{credits} krediiti/sõnum",
      "COMING_SOON": "Varsti saadaval",
      "EDITOR": {
        "TITLE": "Redaktori funktsioonid",
        "DESCRIPTION": "Toetab nutikat kirjutamist, grammatikaparandusi, tooni kohandusi ja sisu täiustamist sõnumiredaktoris."
      },
      "ASSISTANT": {
        "TITLE": "Assistent",
        "DESCRIPTION": "Haldab automatiseeritud vastuseid, vestluste kokkuvõtteid ja nutikaid vastuseettepanekuid kliendisuhtluses."
      },
      "COPILOT": {
        "TITLE": "Kaaspiloot",
        "DESCRIPTION": "Provides real-time contextual suggestions, knowledge base recommendations, and proactive insights during conversations."
      }
    },
    "FEATURES": {
      "TITLE": "Funktsioonid",
      "DESCRIPTION": "Luba või keela AI-põhised funktsioonid.",
      "AUDIO_TRANSCRIPTION": {
        "TITLE": "Heli transkriptsioon",
        "DESCRIPTION": "Muutke automaatselt hääl- ja kõnesalvestused otsitavateks tekstikirjeldusteks."
      },
      "HELP_CENTER_SEARCH": {
        "TITLE": "Abi keskuse otsingu indekseerimine",
        "DESCRIPTION": "Use AI for context aware search inside your help center articles."
      },
      "LABEL_SUGGESTION": {
        "TITLE": "Sildi soovitus",
        "DESCRIPTION": "Paku automaatselt vestluste sisu analüüsi ja konteksti põhjal asjakohaseid silte ja märgendeid.",
        "MODEL_TITLE": "Sildi soovituse mudel",
        "MODEL_DESCRIPTION": "Vali AI mudel vestluste analüüsimiseks ja sobivate siltide soovitamiseks"
      }
    },
    "API": {
      "SUCCESS": "Captain settings updated successfully.",
      "ERROR": "Failed to update Captain settings. Please try again."
    }
  },
  "BILLING_SETTINGS": {
    "TITLE": "Arveldamine",
    "DESCRIPTION": "Halda siin oma tellimust, uuenda plaani ja saa meeskonnale rohkem.",
    "CURRENT_PLAN": {
      "TITLE": "Praegune plaan",
      "PLAN_NOTE": "Oled hetkel tellinud **{plan}** plaani **{quantity}** litsentsiga",
      "SEAT_COUNT": "Istmete arv",
      "RENEWS_ON": "Uueneb kuupäeval"
    },
    "VIEW_PRICING": "Vaata hindu",
    "MANAGE_SUBSCRIPTION": {
      "TITLE": "Halda oma tellimust",
      "DESCRIPTION": "Vaata oma varasemaid arveid, muuda arveldusandmeid või tühista tellimus.",
      "BUTTON_TXT": "Mine arveldusportaali"
    },
    "CAPTAIN": {
      "TITLE": "Kapten",
      "DESCRIPTION": "Halda Captain AI kasutust ja krediite.",
      "BUTTON_TXT": "Osta rohkem krediite",
      "DOCUMENTS": "Dokumendid",
      "RESPONSES": "Responses",
      "UPGRADE": "Captain ei ole tasuta plaanis saadaval, uuenda kohe, et saada ligipääs assistentidele, copilotile ja muule.",
      "REFRESH_CREDITS": "Värskenda"
    },
    "CHAT_WITH_US": {
      "TITLE": "Vajad abi?",
      "DESCRIPTION": "Kas sul on arveldamisega probleeme? Me aitame sind.",
      "BUTTON_TXT": "Vestle meiega"
    },
    "NO_BILLING_USER": "Sinu arvelduskonto seadistatakse. Palun värskenda lehte ja proovi uuesti.",
    "TOPUP": {
      "BUY_CREDITS": "Osta rohkem krediite",
      "MODAL_TITLE": "Osta AI krediite",
      "MODAL_DESCRIPTION": "Purchase additional credits for Captain AI.",
      "CREDITS": "KREDIIDID",
      "ONE_TIME": "ühekordne",
      "POPULAR": "Kõige populaarsem",
      "NOTE_TITLE": "Märkus:",
      "NOTE_DESCRIPTION": "Krediidid lisatakse kohe ja aeguvad 6 kuu pärast. Krediitide kasutamiseks on vajalik aktiivne tellimus. Ostetud krediidid tarbitakse pärast teie kuupõhise plaani krediite.",
      "CANCEL": "Tühista",
      "PURCHASE": "Osta krediite",
      "LOADING": "Valikute laadimine...",
      "FETCH_ERROR": "Krediidivalikute laadimine ebaõnnestus. Palun proovi uuesti.",
      "PURCHASE_ERROR": "Ostu töötlemine ebaõnnestus. Palun proovi uuesti.",
      "PURCHASE_SUCCESS": "Kontole lisati edukalt {credits} krediiti",
      "CONFIRM": {
        "TITLE": "Kinnita ost",
        "DESCRIPTION": "Oled ostmas {credits} krediiti hinnaga {amount}.",
        "INSTANT_DEDUCTION_NOTE": "Sinu salvestatud kaardilt võetakse summa kohe pärast kinnitamist.",
        "GO_BACK": "Tagasi",
        "CONFIRM_PURCHASE": "Kinnita ost"
      }
    }
  },
  "SECURITY_SETTINGS": {
    "TITLE": "Turvalisus",
    "DESCRIPTION": "Halda oma konto turvaseadeid.",
    "LINK_TEXT": "Loe SAML SSO kohta lisaks",
    "SAML_DISABLED_MESSAGE": "SAML SSO on hetkel keelatud. Palun võtke ühendust oma administraatoriga, et see funktsioon lubada.",
    "SAML": {
      "TITLE": "SAML SSO",
      "NOTE": "Configure SAML single sign-on for your account. Users will authenticate through your identity provider instead of using email/password.",
      "ACS_URL": {
        "LABEL": "ACS URL",
        "TOOLTIP": "Assertion Consumer Service URL – seadista see URL oma IdP-s SAML vastuste sihtkohaks"
      },
      "SSO_URL": {
        "LABEL": "SSO URL",
        "HELP": "The URL where SAML authentication requests will be sent",
        "PLACEHOLDER": "https://your-idp.com/saml/sso"
      },
      "CERTIFICATE": {
        "LABEL": "Allkirjastamise sertifikaat PEM formaadis",
        "HELP": "The public certificate from your identity provider used to verify SAML responses",
        "PLACEHOLDER": "-----BEGIN CERTIFICATE-----\nMIIC..."
      },
      "FINGERPRINT": {
        "LABEL": "Sõrmejälg",
        "TOOLTIP": "Sertifikaadi SHA-1 sõrmejälg – kasuta seda sertifikaadi kontrollimiseks oma IdP seadetes"
      },
      "COPY_SUCCESS": "Kopeeritud lõikelauale",
      "SP_ENTITY_ID": {
        "LABEL": "SP üksuse ID",
        "HELP": "Selle rakenduse unikaalne identifikaator teenusepakkujana (automaatselt genereeritud).",
        "TOOLTIP": "Chatwoot unikaalne identifikaator teenusepakkujana – seadista see oma IdP seadetes"
      },
      "IDP_ENTITY_ID": {
        "LABEL": "Identity Provider Entity ID",
        "HELP": "Unique identifier for your identity provider (usually found in IdP configuration)",
        "PLACEHOLDER": "https://your-idp.com/saml"
      },
      "UPDATE_BUTTON": "Uuenda SAML seadeid",
      "API": {
        "SUCCESS": "SAML seaded uuendati edukalt",
        "ERROR": "SAML seadete uuendamine ebaõnnestus",
        "ERROR_LOADING": "SAML seadete laadimine ebaõnnestus",
        "DISABLED": "SAML seaded on edukalt keelatud"
      },
      "VALIDATION": {
        "REQUIRED_FIELDS": "SSO URL, Identity Provider Entity ID ja sertifikaat on kohustuslikud väljad",
        "SSO_URL_ERROR": "Palun sisesta kehtiv SSO URL",
        "CERTIFICATE_ERROR": "Sertifikaat on kohustuslik",
        "IDP_ENTITY_ID_ERROR": "Identity Provider Entity ID is required"
      },
      "ENTERPRISE_PAYWALL": {
        "AVAILABLE_ON": "The SAML SSO feature is only available in the Enterprise plans.",
        "UPGRADE_PROMPT": "Uuenda Enterprise plaanile, et kasutada SAML ühtset sisselogimist ja muid täiustatud turvafunktsioone.",
        "ASK_ADMIN": "Palun pöördu uuendamiseks oma administraatori poole."
      },
      "PAYWALL": {
        "TITLE": "Uuenda, et lubada SAML SSO",
        "AVAILABLE_ON": "The SAML SSO feature is only available in the Enterprise plans.",
        "UPGRADE_PROMPT": "Uuenda oma plaani, et saada ligipääs SAML ühe sisselogimisele ja teistele täiustatud funktsioonidele.",
        "UPGRADE_NOW": "Uuenda kohe",
        "CANCEL_ANYTIME": "Saad oma plaani igal ajal muuta või tühistada"
      },
      "ATTRIBUTE_MAPPING": {
        "TITLE": "SAML atribuudi seadistamine",
        "DESCRIPTION": "The following attribute mappings must be configured in your identity provider"
      },
      "INFO_SECTION": {
        "TITLE": "Teenusepakkuja info",
        "TOOLTIP": "Copy these values and configure them in your Identity Provider to establish the SAML connection"
      }
    }
  },
  "CONVERSATION_WORKFLOW": {
    "INDEX": {
      "HEADER": {
        "TITLE": "Vestluse töövood",
        "DESCRIPTION": "Seadista reeglid ja vajalikud väljad vestluse lahendamiseks."
      }
    },
    "REQUIRED_ATTRIBUTES": {
      "TITLE": "Lahendamisel nõutavad atribuudid",
      "DESCRIPTION": "Vestlust lahendades palutakse agendil täita need atribuudid, kui need pole veel täidetud.",
      "NO_ATTRIBUTES": "Atribuute pole veel lisatud",
      "ADD": {
        "TITLE": "Lisa atribuute",
        "SEARCH_PLACEHOLDER": "Otsi atribuute"
      },
      "SAVE": {
        "SUCCESS": "Nõutavad atribuudid uuendatud",
        "ERROR": "Nõutavate atribuutide uuendamine ebaõnnestus, palun proovi uuesti"
      },
      "MODAL": {
        "TITLE": "Lahenda vestlus",
        "DESCRIPTION": "Palun täida enne selle vestluse lahendamist järgmised kohandatud atribuudid",
        "ACTIONS": {
          "RESOLVE": "Lahenda vestlus",
          "CANCEL": "Tühista"
        },
        "PLACEHOLDERS": {
          "TEXT": "Kirjuta märkus...",
          "NUMBER": "Sisesta number",
          "LINK": "Lisa link",
          "DATE": "Vali kuupäev",
          "LIST": "Vali valik"
        },
        "CHECKBOX": {
          "YES": "Jah",
          "NO": "Ei"
        }
      },
      "PAYWALL": {
        "TITLE": "Uuenda, et kasutada nõutavaid atribuute",
        "AVAILABLE_ON": "The required conversation attributes feature is available on the Business and Enterprise plans.",
        "UPGRADE_PROMPT": "Uuenda oma plaani, et paluda agentidel täita nõutavad atribuudid enne vestluse lahendamist.",
        "UPGRADE_NOW": "Uuenda kohe",
        "CANCEL_ANYTIME": "Saad oma plaani igal ajal muuta või tühistada"
      },
      "ENTERPRISE_PAYWALL": {
        "AVAILABLE_ON": "Nõutavate vestluse atribuutide funktsioon on saadaval tasulistes plaanides.",
        "UPGRADE_PROMPT": "Uuenda tasulisele plaanile, et nõuda atribuutide täitmist enne vestluse lõpetamist.",
        "ASK_ADMIN": "Palun pöördu uuenduse saamiseks oma administraatori poole."
      }
    }
  },
  "CREATE_ACCOUNT": {
    "NO_ACCOUNT_WARNING": "Oih! Ühtegi Chatwoot kontot ei leitud. Jätkamiseks loo uus konto.",
    "NEW_ACCOUNT": "Uus konto",
    "SELECTOR_SUBTITLE": "Loo uus konto",
    "API": {
      "SUCCESS_MESSAGE": "Konto on edukalt loodud",
      "EXIST_MESSAGE": "Konto juba eksisteerib",
      "ERROR_MESSAGE": "Ei õnnestunud Chatwoot serveriga ühendust luua, palun proovi hiljem uuesti"
    },
    "FORM": {
      "NAME": {
        "LABEL": "Ettevõtte nimi",
        "PLACEHOLDER": "Wayne Enterprises"
      },
      "SUBMIT": "Esita",
      "CANCEL": "Tühista"
    }
  },
  "KEYBOARD_SHORTCUTS": {
    "TOGGLE_MODAL": "Vaata kõiki otseteid",
    "TITLE": {
      "OPEN_CONVERSATION": "Ava vestlus",
      "RESOLVE_AND_NEXT": "Lahenda ja liigu järgmisele",
      "NAVIGATE_DROPDOWN": "Liigu rippmenüü üksuste vahel",
      "RESOLVE_CONVERSATION": "Lahenda vestlus",
      "GO_TO_CONVERSATION_DASHBOARD": "Mine vestluste juhtpaneelile",
      "ADD_ATTACHMENT": "Lisa manus",
      "GO_TO_CONTACTS_DASHBOARD": "Mine kontaktide juhtpaneelile",
      "TOGGLE_SIDEBAR": "Vaheta külgriba",
      "GO_TO_REPORTS_SIDEBAR": "Mine aruannete külgribale",
      "MOVE_TO_NEXT_TAB": "Liigu järgmisele vahelehele vestluste nimekirjas",
      "GO_TO_SETTINGS": "Mine seadistustesse",
      "SWITCH_TO_PRIVATE_NOTE": "Vaheta privaatse märkuse peale",
      "SWITCH_TO_REPLY": "Vaheta vastuse peale",
      "TOGGLE_SNOOZE_DROPDOWN": "Vaheta unerežiimi rippmenüüd"
    }
  },
  "ASSIGNMENT_POLICY": {
    "INDEX": {
      "HEADER": {
        "TITLE": "Esindaja määramine",
        "DESCRIPTION": "Määra poliitikad, et tõhusalt hallata töökoormust ja suunata vestlusi vastavalt postkastide ja esindajate vajadustele. Loe siit lisaks"
      },
      "ASSIGNMENT_POLICY": {
        "TITLE": "Määramise poliitika",
        "DESCRIPTION": "Halda, kuidas vestlused postkastides määratakse.",
        "FEATURES": [
          "Määra vestlused ühtlaselt või saadavuse alusel",
          "Lisa õiglane jaotusreeglid, et vältida ühegi esindaja ülekoormamist",
          "Lisa poliitikasse postkastid – üks poliitika postkasti kohta"
        ]
      },
      "AGENT_CAPACITY_POLICY": {
        "TITLE": "Esindaja töökoormuse poliitika",
        "DESCRIPTION": "Halda esindajate töökoormust.",
        "FEATURES": [
          "Määra maksimaalne vestluste arv postkasti kohta",
          "Loo erandid siltide ja aja alusel",
          "Lisa poliitikasse esindajad – üks poliitika esindaja kohta"
        ]
      }
    },
    "AGENT_ASSIGNMENT_POLICY": {
      "INDEX": {
        "HEADER": {
          "TITLE": "Määramise poliitika",
          "CREATE_POLICY": "Uus poliitika"
        },
        "CARD": {
          "ORDER": "Järjekord",
          "PRIORITY": "Prioriteet",
          "ACTIVE": "Aktiivne",
          "INACTIVE": "Mitteaktiivne",
          "POPOVER": "Lisatud postkastid",
          "EDIT": "Muuda"
        },
        "NO_RECORDS_FOUND": "Määramisreegleid ei leitud"
      },
      "CREATE": {
        "HEADER": {
          "TITLE": "Loo määramisreegel"
        },
        "CREATE_BUTTON": "Loo reegel",
        "API": {
          "SUCCESS_MESSAGE": "Määramisreegel loodud edukalt",
          "ERROR_MESSAGE": "Määramisreegli loomine ebaõnnestus",
          "INBOX_LINKED": "Sissetulek on poliitikaga seotud"
        }
      },
      "EDIT": {
        "HEADER": {
          "TITLE": "Muuda määramisreeglit"
        },
        "EDIT_BUTTON": "Uuenda reeglit",
        "CONFIRM_ADD_INBOX_DIALOG": {
          "TITLE": "Lisa postkast",
          "DESCRIPTION": "{inboxName} postkast on juba seotud teise reegliga. Kas oled kindel, et soovid selle siduda selle reegliga? See eemaldatakse teisest reeglist.",
          "CONFIRM_BUTTON_LABEL": "Jätka",
          "CANCEL_BUTTON_LABEL": "Tühista"
        },
        "INBOX_LINK_PROMPT": {
          "TITLE": "Seosta sissetulek poliitikaga",
          "DESCRIPTION": "Kas soovid selle sissetuleku siduda määramisreegliga?",
          "LINK_BUTTON": "Seosta sissetulek",
          "CANCEL_BUTTON": "Jäta vahele"
        },
        "API": {
          "SUCCESS_MESSAGE": "Määramisreegel uuendati edukalt",
          "ERROR_MESSAGE": "Määramisreegli uuendamine ebaõnnestus"
        },
        "INBOX_API": {
          "ADD": {
            "SUCCESS_MESSAGE": "Postkast lisati reeglile edukalt",
            "ERROR_MESSAGE": "Postkasti lisamine reeglile ebaõnnestus"
          },
          "REMOVE": {
            "SUCCESS_MESSAGE": "Postkast eemaldati reeglist edukalt",
            "ERROR_MESSAGE": "Postkasti eemaldamine reeglist ebaõnnestus"
          }
        }
      },
      "FORM": {
        "NAME": {
          "LABEL": "Reegli nimi:",
          "PLACEHOLDER": "Sisesta reegli nimi"
        },
        "DESCRIPTION": {
          "LABEL": "Kirjeldus:",
          "PLACEHOLDER": "Sisesta kirjeldus"
        },
        "STATUS": {
          "LABEL": "Staatus:",
          "PLACEHOLDER": "Vali staatus",
          "ACTIVE": "Reegel on aktiivne",
          "INACTIVE": "Reegel on mitteaktiivne"
        },
        "ASSIGNMENT_ORDER": {
          "LABEL": "Määramise järjekord",
          "ROUND_ROBIN": {
            "LABEL": "Ringjaotus",
            "DESCRIPTION": "Määra vestlused võrdselt agendile."
          },
          "BALANCED": {
            "LABEL": "Tasakaalustatud",
            "DESCRIPTION": "Määra vestlused saadaval oleva mahutavuse põhjal.",
            "PREMIUM_MESSAGE": "Uuenda, et kasutada tasakaalustatud määramist ja agendi võimekuse haldust.",
            "PREMIUM_BADGE": "Premium"
          }
        },
        "ASSIGNMENT_PRIORITY": {
          "LABEL": "Määramise prioriteet",
          "EARLIEST_CREATED": {
            "LABEL": "Kõige varasemalt loodud",
            "DESCRIPTION": "Kõige varem loodud vestlus määratakse esimesena."
          },
          "LONGEST_WAITING": {
            "LABEL": "Kõige kauem oodanud",
            "DESCRIPTION": "Kõige kauem oodanud vestlus määratakse esimesena."
          }
        },
        "FAIR_DISTRIBUTION": {
          "LABEL": "Õiglase jaotuse reegel",
          "DESCRIPTION": "Määra maksimaalne vestluste arv, mis võib ajaühikus agendile määrata, et vältida ühe agendi ülekoormamist. See kohustuslik väli on vaikimisi 100 vestlust tunnis.",
          "INPUT_MAX": "Määra maksimaalne",
          "DURATION": "Vestlused agendi kohta iga"
        },
        "INBOXES": {
          "LABEL": "Lisatud postkastid",
          "DESCRIPTION": "Lisa postkastid, millele see reegel kehtib.",
          "ADD_BUTTON": "Lisa postkast",
          "DROPDOWN": {
            "SEARCH_PLACEHOLDER": "Otsi ja vali postkastid lisamiseks",
            "ADD_BUTTON": "Lisa"
          },
          "EMPTY_STATE": "Sellesse reeglisse pole postkaste lisatud, alusta postkastiga",
          "API": {
            "SUCCESS_MESSAGE": "Postkast lisati reeglile edukalt",
            "ERROR_MESSAGE": "Postkasti lisamine reeglile ebaõnnestus"
          }
        }
      },
      "DELETE_POLICY": {
        "SUCCESS_MESSAGE": "Määramisreegel kustutati edukalt",
        "ERROR_MESSAGE": "Määramisreegli kustutamine ebaõnnestus"
      }
    },
    "AGENT_CAPACITY_POLICY": {
      "INDEX": {
        "HEADER": {
          "TITLE": "Agendi mahutavus",
          "CREATE_POLICY": "Uus reegel"
        },
        "CARD": {
          "POPOVER": "Lisatud agendid",
          "EDIT": "Muuda"
        },
        "NO_RECORDS_FOUND": "Agendi mahutavuse reegleid ei leitud"
      },
      "CREATE": {
        "HEADER": {
          "TITLE": "Loo agendi mahutavuse reegel"
        },
        "CREATE_BUTTON": "Loo reegel",
        "API": {
          "SUCCESS_MESSAGE": "Agendi mahutavuse reegel loodud edukalt",
          "ERROR_MESSAGE": "Agendi mahutavuse reegli loomine ebaõnnestus"
        }
      },
      "EDIT": {
        "HEADER": {
          "TITLE": "Muuda agendi mahutavuse reeglit"
        },
        "EDIT_BUTTON": "Uuenda reeglit",
        "CONFIRM_ADD_AGENT_DIALOG": {
          "TITLE": "Lisa agent",
          "DESCRIPTION": "{agentName} on juba seotud teise reegliga. Kas oled kindel, et soovid selle siduda selle reegliga? See eemaldatakse teisest reeglist.",
          "CONFIRM_BUTTON_LABEL": "Jätka",
          "CANCEL_BUTTON_LABEL": "Tühista"
        },
        "API": {
          "SUCCESS_MESSAGE": "Agendi mahutavuse reegel uuendati edukalt",
          "ERROR_MESSAGE": "Agendi mahutavuse reegli uuendamine ebaõnnestus"
        },
        "AGENT_API": {
          "ADD": {
            "SUCCESS_MESSAGE": "Agent lisati reeglile edukalt",
            "ERROR_MESSAGE": "Agendi lisamine reeglile ebaõnnestus"
          },
          "REMOVE": {
            "SUCCESS_MESSAGE": "Agent eemaldati reeglist edukalt",
            "ERROR_MESSAGE": "Agendi eemaldamine poliitikast ebaõnnestus"
          }
        },
        "INBOX_LIMIT_API": {
          "ADD": {
            "SUCCESS_MESSAGE": "Sissetuleku limiit lisatud edukalt",
            "ERROR_MESSAGE": "Sissetuleku limiidi lisamine ebaõnnestus"
          },
          "UPDATE": {
            "SUCCESS_MESSAGE": "Sissetuleku limiit uuendatud edukalt",
            "ERROR_MESSAGE": "Sissetuleku limiidi uuendamine ebaõnnestus"
          },
          "DELETE": {
            "SUCCESS_MESSAGE": "Sissetuleku limiit kustutatud edukalt",
            "ERROR_MESSAGE": "Sissetuleku limiidi kustutamine ebaõnnestus"
          }
        }
      },
      "FORM": {
        "NAME": {
          "LABEL": "Poliitika nimi:",
          "PLACEHOLDER": "Sisesta poliitika nimi"
        },
        "DESCRIPTION": {
          "LABEL": "Kirjeldus:",
          "PLACEHOLDER": "Sisesta kirjeldus"
        },
        "INBOX_CAPACITY_LIMIT": {
          "LABEL": "Sissetulevate sõnumite mahu piirangud",
          "ADD_BUTTON": "Lisa postkast",
          "FIELD": {
            "SELECT_INBOX": "Vali postkast",
            "MAX_CONVERSATIONS": "Maksimaalne vestluste arv",
            "SET_LIMIT": "Sea piirang"
          },
          "EMPTY_STATE": "Piirangut pole seatud"
        },
        "EXCLUSION_RULES": {
          "LABEL": "Väljaarvamise reeglid",
          "DESCRIPTION": "Vestlused, mis vastavad järgmistele tingimustele, ei arvata agendi mahusse",
          "TAGS": {
            "LABEL": "Jäta välja vestlused, millel on kindlad sildid",
            "ADD_TAG": "lisa silt",
            "DROPDOWN": {
              "SEARCH_PLACEHOLDER": "Otsi ja vali lisatavad sildid"
            },
            "EMPTY_STATE": "Sellesse poliitikasse pole silte lisatud."
          },
          "DURATION": {
            "LABEL": "Jäta välja vestlused, mis on vanemad kui määratud kestus",
            "PLACEHOLDER": "Sea aeg"
          }
        },
        "USERS": {
          "LABEL": "Määratud agendid",
          "DESCRIPTION": "Lisa agendid, kellele see poliitika kehtib.",
          "ADD_BUTTON": "Lisa agent",
          "DROPDOWN": {
            "SEARCH_PLACEHOLDER": "Otsi ja vali lisatavad agendid",
            "ADD_BUTTON": "Lisa"
          },
          "EMPTY_STATE": "Agente pole lisatud",
          "API": {
            "SUCCESS_MESSAGE": "Agent lisati poliitikasse edukalt",
            "ERROR_MESSAGE": "Agendi lisamine poliitikasse ebaõnnestus"
          }
        }
      },
      "DELETE_POLICY": {
        "SUCCESS_MESSAGE": "Agendi mahutavuse reegel kustutati edukalt",
        "ERROR_MESSAGE": "Agendi mahutavuse reegli kustutamine ebaõnnestus"
      }
    },
    "DELETE_POLICY": {
      "TITLE": "Kustuta reegel",
      "DESCRIPTION": "Kas oled kindel, et soovid selle reegli kustutada? Seda toimingut ei saa tagasi võtta.",
      "CONFIRM_BUTTON_LABEL": "Kustuta",
      "CANCEL_BUTTON_LABEL": "Tühista"
    }
  }
}
